import { render, staticRenderFns } from "./Agreement.vue?vue&type=template&id=085ecb96&scoped=true"
import script from "./Agreement.vue?vue&type=script&lang=ts"
export * from "./Agreement.vue?vue&type=script&lang=ts"
import style0 from "./Agreement.vue?vue&type=style&index=0&id=085ecb96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085ecb96",
  null
  
)

export default component.exports